import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgQuote() {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [_jsx("path", {
      clipRule: "evenodd",
      d: "M16.363 1.586A2 2 0 0014.948 1H4.777c-1.243 0-2 1-2 2v18c0 1.215.757 2 2 2H18.75c1.243 0 2.027-.785 2.027-2V6.828a2 2 0 00-.586-1.414l-3.828-3.828z",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0), _jsx("path", {
      d: "M14.777 2v4a1 1 0 001 1h4",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0), _jsx("path", {
      d: "M14.892 14.592c0 .657-.109 1.232-.327 1.723-.218.489-.52.881-.903 1.177l1.147.908-1.06.899-1.528-1.23c-.143.019-.286.029-.43.029-.605 0-1.142-.14-1.61-.42a2.871 2.871 0 01-1.1-1.201c-.26-.521-.395-1.12-.405-1.797v-.376c0-.7.127-1.315.381-1.846.257-.53.622-.94 1.094-1.23.475-.29 1.019-.435 1.63-.435.603 0 1.14.143 1.612.43.472.286.838.695 1.099 1.225.263.528.397 1.133.4 1.817v.327zm-1.743-.298c0-.706-.119-1.242-.356-1.607a1.129 1.129 0 00-1.011-.551c-.453 0-.793.18-1.02.542-.229.361-.344.89-.347 1.587v.327c0 .7.115 1.237.346 1.611.231.371.575.557 1.03.557.437 0 .77-.184 1.002-.552.234-.368.353-.897.356-1.587v-.327z",
      fill: "currentColor"
    }, void 0)]
  }), void 0);
}

export default SvgQuote;